__turbopack_context__.v({
  "alt": "ExplainerFigure-module__Zgok1G__alt",
  "caption": "ExplainerFigure-module__Zgok1G__caption",
  "figure": "ExplainerFigure-module__Zgok1G__figure",
});
